// extracted by mini-css-extract-plugin
export default {"opinion":"Opinion_opinion__EzWb+"};